import { CompassContextType } from '@/src/libs/CompassContext';

export const areFiltersActive = (
  ctx: CompassContextType | undefined
): boolean => {
  if (!ctx) return false;
  const { day, type, time } = ctx.state.filters;
  return !!day.length || !!type.length || !!time.compare;
};
